import type { ViewerPlugin } from './../ricos-types/index.js';

import type { ViewerPluginOptions } from './types.js';

export const isViewerPlugin = (
  pluginOrConfig: ViewerPlugin | ViewerPluginOptions
): pluginOrConfig is ViewerPlugin => {
  return 'config' in pluginOrConfig;
};

export const isViewerPluginOptions = (
  pluginOrConfig: ViewerPlugin | ViewerPluginOptions
): pluginOrConfig is ViewerPluginOptions => {
  return !('config' in pluginOrConfig);
};
